// extracted by mini-css-extract-plugin
export default {"root":"IconEnquiry_root__xghIU","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__PhC63"};